export enum DepMemberEducation {
No,
SecondStep,
ThirdStep,
}
